export default __webpack_public_path__ + "static/media/seller.370fe3fa.png";